import moment from 'moment';

export default {
  install(Vue) {
    Vue.filter('sanitizer', (value) => {
      if (!value) return '-';
      return value;
    });

    // Vue.filter('date', (value, format, sourceFormat) => {
    //   if (!value) return '-';
    //   return moment.utc(value, sourceFormat).format(format || 'DD/MM/YYYY');
    // });
    Vue.filter('date', (value, format) => {
      if (!value) return '-';
      if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = value.split('-');
        return moment([year, month - 1, day]).format(format || 'DD/MM/YYYY');
      }
      return moment(value).format(format);
    });

    Vue.filter('datetime', (value, format) => {
      if (!value) return '-';
      return moment(value).format(format || 'DD/MM/YYYY HH:mm');
    });
    Vue.filter('datetimeseconds', (value, format) => {
      if (!value) return '-';
      return moment(value).format(format || 'DD/MM/YYYY HH:mm:ss');
    });
  },
};
